const paper_2_2k25 = {
  questions: {
    1: "1",
    2: "1",
    3: "1",
    4: "1",
    5: "2",
    6: "2",
    7: "2",
    8: "2",
    9: "3",
    10: "3",
    11: "3",
    12: "3",
    13: "3",
    14: "3",
    15: "3",
    16: "3",
    17: "1",
    18: "1",
    19: "1",
    20: "1",
    21: "2",
    22: "2",
    23: "2",
    24: "2",
    25: "3",
    26: "3",
    27: "3",
    28: "3",
    29: "3",
    30: "3",
    31: "3",
    32: "3",
    33: "1",
    34: "1",
    35: "1",
    36: "1",
    37: "2",
    38: "2",
    39: "2",
    40: "2",
    41: "3",
    42: "3",
    43: "3",
    44: "3",
    45: "3",
    46: "3",
    47: "3",
    48: "3",
  },
  sections: {
    1: [1, 17, 33],
    2: [5, 21, 37],
    3: [9, 25, 41],
  },
};

export default paper_2_2k25;
